module.exports = __webpack_public_path__ + "static/media/2.2c6ec524.jpg";